import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ComputerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 2.86526H13C13.2761 2.86526 13.5 3.08912 13.5 3.36526V9.36526C13.5 9.6414 13.2761 9.86526 13 9.86526H3C2.72386 9.86526 2.5 9.6414 2.5 9.36526V3.36526C2.5 3.08912 2.72386 2.86526 3 2.86526ZM1 3.36526C1 2.26069 1.89543 1.36526 3 1.36526H13C14.1046 1.36526 15 2.26069 15 3.36526V9.36526C15 10.4699 14.1046 11.3653 13 11.3653H3C1.89543 11.3653 1 10.4699 1 9.36526V3.36526ZM7 12.3653H9V13.3653C9 13.6414 9.22386 13.8653 9.5 13.8653C10.3284 13.8653 11 14.5369 11 15.3653H5C5 14.5369 5.67157 13.8653 6.5 13.8653C6.77614 13.8653 7 13.6414 7 13.3653V12.3653Z"
		/>
	</svg>
))
